var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Hero',{attrs:{"page-title":_vm.pageTitle}}),_c('div',{staticClass:"container"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_c('br'),_c('br'),_c('br'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }